import axios from "axios";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiLinkContext } from "../../context/ApiLinkContext";
import { LanguageContext } from "../../context/LanguageContext";
import translations from "../../data/langData";

const CvInsert = () => {
  const { cvCategory } = useContext(ApiLinkContext);
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  const workExperience = [
    { id: 0, value: 0, title: t.birildenaz },
    { id: 1, value: 1, title: t.birildenucileqeder },
    { id: 2, value: 2, title: t.ucilden5ileqeder },
    { id: 3, value: 3, title: t.besildencox },
  ];

  const education = [
    { id: 0, value: 0, title: t.ali },
    { id: 1, value: 1, title: t.natamam },
    { id: 2, value: 2, title: t.orta},
  ];

  const workingMode = [
    { id: 0, value: 0, title: t.tamstat },
    { id: 1, value: 1, title: t.yarim },
    { id: 2, value: 2, title: t.frilans },
    { id: 3, value: 3, title: t.tecrubeci },
    { id: 4, value: 4, title: t.uzaqdan },
    { id: 5, value: 5, title: t.muveqqeti },
  ];


  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    ad: "",
    soyad: "",
    ata: "",
    cins: "0",
    yash: "18",
    shekil: null,
    tehsil: "Elmi dərəcə",
    tehsil_etrafli: "",
    isht: "1 ildən aşağı",
    etrafli_isht: "",
    kateqoriya: "",
    vezife: "",
    sheher: "",
    emekhaqqi: "",
    bacariqlar: "",
    melumat: "",
    email: "",
    telefon: "",

    dil: "",
    rejim: "",
  });
  const [jwtToken] = useState(localStorage.getItem("jwt") || "");
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setInputs((prev) => ({ ...prev, shekil: file }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Şəkili çıxmaq şərti ilə bütün məlumatları JSON obyekt kimi göndəririk
    const dataToSend = {
      ad: inputs.ad,
      soyad: inputs.soyad,
      ata: inputs.ata,
      cins: inputs.cins,
      yash: inputs.yash,
      tehsil: inputs.tehsil,
      tehsil_etrafli: inputs.tehsil_etrafli,
      isht: inputs.isht,
      etrafli_isht: inputs.etrafli_isht,
      kateqoriya: inputs.kateqoriya,
      vezife: inputs.vezife,
      sheher: inputs.sheher,
      emekhaqqi: inputs.emekhaqqi,
      bacariqlar: inputs.bacariqlar,
      melumat: inputs.melumat,
      email: inputs.email,
      telefon: inputs.telefon,
      dil: inputs.dil,
      rejim: inputs.rejim,
    };

    // Axios ilə JSON POST sorğusu göndəririk
    axios
      .post("https://www.turanozbahceci.com/api/cv.php", dataToSend, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        navigate("/jobpostings");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="myaccount-content">
      <h3>{t.cvyerlesdirmek}</h3>
      <form onSubmit={handleSubmit}>
        <div className="myaccount-table table-responsive text-start">
          <div className="container">
            <div className="row g-3">
              <div className="col-lg-6 col-sm-6 col-12">
                <p>
                  {t.name} <span className="text-danger">*</span>
                </p>
                <input
                  type="text"
                  name="ad"
                  value={inputs.ad}
                  onChange={handleChange}
                  placeholder={t.name}
                  required
                />
              </div>

              <div className="col-lg-6 col-sm-6 col-12">
                <p>
                  {t.lastname} <span className="text-danger">*</span>
                </p>
                <input
                  type="text"
                  name="soyad"
                  value={inputs.soyad}
                  onChange={handleChange}
                  placeholder={t.lastname}
                  required
                />
              </div>

              <div className="col-lg-6 col-sm-6 col-12">
                <p>
                  {t.fathername} <span className="text-danger">*</span>
                </p>
                <input
                  type="text"
                  name="ata"
                  value={inputs.ata}
                  onChange={handleChange}
                  placeholder={t.fathername}
                  required
                />
              </div>

              <div className="col-lg-6 col-sm-6 col-12">
                <p>
                  {t.gender} <span className="text-danger">*</span>
                </p>
                <select
                  name="cins"
                  id="cvSelect"
                  value={inputs.cins}
                  onChange={handleChange}
                  required
                >
                  <option value="" selected disabled>{t.select}</option>
                  <option value="0">{t.man}</option>
                  <option value="1">{t.woman}</option>
                </select>
              </div>

              <div className="col-lg-6 col-sm-6 col-12">
                <p>
                  {t.old} <span className="text-danger">*</span>
                </p>
                <select
                  name="yash"
                  id="cvSelect"
                  value={inputs.yash}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled selected>{t.select}</option>
                  {[...Array(65 - 18 + 1)].map((_, index) => {
                    const age = 18 + index;
                    return (
                      <option key={age} value={age}>
                        {age}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="col-lg-6 col-sm-6 col-12">
                <p>{t.img}</p>
                <input type="file" onChange={handleFileChange} />
              </div>

              <div className="col-12">
                <p>
                  {t.education} <span className="text-danger">*</span>
                </p>
                <select
                  name="tehsil"
                  id="cvSelect"
                  value={inputs.tehsil}
                  onChange={handleChange}
                  required
                >
                     <option value="" disabled selected>{t.select}</option>
                  {education.map((item) => (
                    <option key={item.id} value={item.value}>
                      {item.title}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-12">
                <p>{t.etrafli}</p>
                <textarea
                  name="tehsil_etrafli"
                  value={inputs.tehsil_etrafli}
                  onChange={handleChange}
                  placeholder={t.ozunuz}
                  required
                  
                ></textarea>
              </div>

              <div className="col-12">
                <p>
                  {t.istecrubesi} <span className="text-danger">*</span>
                </p>
                <select
                  name="isht"
                  id="cvSelect"
                  value={inputs.isht}
                  onChange={handleChange}
                  required
                  
                >
                  <option value="" disabled selected>{t.select}</option>
                  {workExperience.map((item) => (
                    <option key={item.id} value={item.value}>
                      {item.title}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-12">
                <p>
                  {t.isrejimi}  <span className="text-danger">*</span>
                </p>
                <select
                  name="rejim"
                  id="cvSelect"
                  value={inputs.rejim}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled selected>{t.select}</option>
                  {workingMode.map((item) => (
                    <option key={item.id} value={item.value}>
                      {item.title}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-12">
                <p>{t.etrafli}</p>
                <textarea
                  name="etrafli_isht"
                  value={inputs.etrafli_isht}
                  onChange={handleChange}
                  placeholder={t.istecrubesihaqqinda}
                  required
                ></textarea>
              </div>

              <div className="col-lg-12 col-sm-6 col-12">
                <p>
                  {t.dilbilikleri}  <span className="text-danger">*</span>
                </p>
                <input
                  type="text"
                  name="dil"
                  value={inputs.dil}
                  onChange={handleChange}
                  placeholder={t.dilbilikleri}
                  required
                />
              </div>

              <div className="col-lg-6 col-sm-6 col-12">
                <p>
                  {t.vezife} <span className="text-danger">*</span>
                </p>
                <input
                  type="text"
                  name="vezife"
                  value={inputs.vezife}
                  onChange={handleChange}
                  placeholder={t.vezife}
                  required
                />
              </div>

              <div className="col-lg-6 col-sm-6 col-12">
                <p>
                  {t.city} <span className="text-danger">*</span>
                </p>
                <input
                  type="text"
                  name="sheher"
                  value={inputs.sheher}
                  onChange={handleChange}
                  placeholder={t.city}
                  required
                />
              </div>

              <div className="col-lg-6 col-sm-6 col-12">
                <p>
                  {t.min_maas} (AZN){" "}
                  <span className="text-danger">*</span>
                </p>
                <input
                  type="text"
                  name="emekhaqqi"
                  value={inputs.emekhaqqi}
                  onChange={handleChange}
                  placeholder={t.min_maas}
                  required
                />
              </div>
              <div className="col-lg-6 col-sm-6 col-12">
                <p>
                  {t.kateqoriya} <span className="text-danger">*</span>
                </p>
                <select
                  name="kateqoriya"
                  id="cvSelect"
                  value={inputs.kateqoriya}
                  onChange={handleChange}
                  required
                >
                  <option value="" selected disabled>{t.select}</option>
                  {cvCategory &&
                    cvCategory.map((item) => (
                      <option key={item} value={item.id}>
                        {language == "az"
                          ? item.name
                          : language == "en"
                          ? item.name_en
                          : language == "ru"
                          ? item.name_ru
                          : language == "tr"
                          ? item.name_tr
                          : language == "de"
                          ? item.name_de
                          : language == "pl"
                          ? item.name_pl
                          : ""}
                      </option>
                    ))}
                </select>
              </div>

              <div className="col-12">
                <p>Bacarıqlar</p>
                <textarea
                  name="bacariqlar"
                  value={inputs.bacariqlar}
                  onChange={handleChange}
                  placeholder="Bacarıqlarınız"
                  required
                ></textarea>
              </div>

              <div className="col-12">
                <p>{t.elavemelumat}</p>
                <textarea
                  name="melumat"
                  value={inputs.melumat}
                  onChange={handleChange}
                  placeholder={t.elavemelumat}
                  required
                ></textarea>
              </div>

              <div className="col-12">
                <p>
                  {t.address} <span className="text-danger">*</span>
                </p>
                <input
                  type="email"
                  name="email"
                  value={inputs.email}
                  onChange={handleChange}
                  placeholder={t.address}
                  required
                />
              </div>

              <div className="col-12">
                <p>
                  {t.mobil} <span className="text-danger">*</span>
                </p>
                <input
                  type="text"
                  name="telefon"
                  value={inputs.telefon}
                  onChange={handleChange}
                  placeholder="(011) 222-33-44"
                  required
                />
              </div>

              <div className="d-flex justify-content-center align-items-center">
                <button type="submit" className="w-100 btn btn-primary">
                  {t.yerlesdirin}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CvInsert;
